import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type {
  SetQueryPayloadActionType,
  UserListOptionType,
  UserListStateType,
} from 'features/ABAdmin/@types/UserList'

export const SLICE_NAME_AB_ADMIN_USER_LIST = 'abAdminUserList'

export const initialState: UserListStateType = {
  isLoading: false,
  list: [],
  channelOptions: [],
  typeOptions: [],
  query: {
    user_id: '',
    target_channel: { name: '', value: '' },
    type: { name: '', value: '' },
    assignment_status: { name: '', value: '' },
    page_index: 0,
    page_size: 10,
  },
}

const abAdminUserList = createSlice({
  name: SLICE_NAME_AB_ADMIN_USER_LIST,
  initialState,
  reducers: {
    reset: () => initialState,
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setList: (state, action: PayloadAction<UserListStateType['list']>) => {
      state.list = action.payload
    },
    setChannelOptions: (state, action: PayloadAction<UserListOptionType[]>) => {
      state.channelOptions = action.payload
    },
    setTypeOptions: (state, action: PayloadAction<UserListOptionType[]>) => {
      state.typeOptions = action.payload
    },
    setQuery: (state, action: PayloadAction<SetQueryPayloadActionType>) => {
      state.query = { ...state.query, ...action.payload }
    },
  },
})

export const { reset, setIsLoading, setList, setChannelOptions, setTypeOptions, setQuery } =
  abAdminUserList.actions

export default abAdminUserList.reducer
